/**
 * The single definition of what a benchmark is called and what colour it is drawn in.
 *
 * Four places have to agree: the chart line, the chart legend, the checkbox swatch in the
 * Dashboard toolbar, and the annual table header. A swatch that does not match its own
 * line is worse than no swatch at all — it silently mislabels which curve is which — so
 * none of those places is allowed its own copy.
 *
 * `themeKey` indexes src/theme.js, which resolves at runtime; the colours are therefore
 * read through benchmarkSwatchVars(theme) rather than written down here.
 */

export const BENCHMARKS = {
  BTCUSD: { label: 'BTC', themeKey: 'quaternary' },
  SP500: { label: 'S&P 500', themeKey: 'secondary' },
  GOLD: { label: 'GOLD/$', themeKey: 'tertiary' }
}

export const BENCHMARK_KEYS = Object.keys(BENCHMARKS)

/* Shape FormBoxes expects for :options — { value: 'Label' }. */

export function benchmarkOptions() {
  const options = {}

  BENCHMARK_KEYS.forEach((key) => {
    options[key] = BENCHMARKS[key].label
  })

  return options
}

/* CSS custom properties, so the checkbox swatches can be coloured from the same theme
   lookup the Chart.js datasets use instead of a hardcoded SASS literal. */

export function benchmarkSwatchVars(theme) {
  const vars = {}

  if (!theme) {
    return vars
  }

  BENCHMARK_KEYS.forEach((key) => {
    vars['--swatch-' + key.toLowerCase()] = theme[BENCHMARKS[key].themeKey]
  })

  return vars
}
